/**
 * Goods receipt detail — document view of a posted GRN.
 *
 * @see prototype/purchases/goods-receipt-detail.html — V1.1 baseline
 */
import { createFileRoute, notFound } from "@tanstack/react-router";
import { hasPermission } from "@flint/api-contract";
import { WorkspaceShell } from "../../../../features/workspace/index.ts";
import { GrnDetailPage } from "../../../../features/goods-receipts/index.ts";
import { meQueryOptions } from "../../../../lib/session.ts";

export const Route = createFileRoute("/(workspace)/procurement/goods-receipts/$grnId/")({
  beforeLoad: async ({ context }) => {
    const me = await context.queryClient.ensureQueryData(meQueryOptions).catch(() => null);
    const perms = me?.company?.permissions ?? [];
    if (!hasPermission(perms, "goodsReceipts.view")) {
      throw notFound();
    }
  },
  component: GoodsReceiptDetailRoute,
});

function GoodsReceiptDetailRoute() {
  const { grnId } = Route.useParams();
  return (
    <WorkspaceShell
      breadcrumbs={[
        { label: "Procurement", to: "/" },
        { label: "Goods receipts", to: "/procurement/goods-receipts" },
        { label: "Detail" },
      ]}
      contentClassName="max-w-none"
      viewportClassName="p-0 md:p-0"
    >
      <GrnDetailPage grnId={grnId} />
    </WorkspaceShell>
  );
}
